import React from "react";
import { Modal } from "react-bootstrap";
export default function ModalMain(_a) {
    var title = _a.title, close = _a.close, open = _a.open, variant = _a.variant, children = _a.children;
    return React.createElement(Modal, { show: open, size: 'xl', centered: true, onHide: close },
        React.createElement(Modal.Header, { closeButton: true, className: 'bg-' + variant },
            React.createElement("h6", { className: "m-0 font-weight-bold text-primary mr-auto align-self-center" },
                React.createElement("span", null,
                    React.createElement("b", null, title)))),
        children);
}
//# sourceMappingURL=Main.js.map